import React, { useEffect, useState } from 'react'
import '../css/gallery.css';
import { Helmet } from 'react-helmet';
import { fetchGallery } from '../utils/galleryData';
import { resolveImageUrl } from '../utils/driveImage';
import { GALLERY_PHOTO_FALLBACKS } from '../images/galleryPhotos';
import comingSoon from '../images/coming_soon.jpg';

function GalleryPhoto({ item }) {
    const fallback = GALLERY_PHOTO_FALLBACKS[item.photo_key] || comingSoon;
    const src = item.photo_url ? resolveImageUrl(item.photo_url) : fallback;
    const position = item.photo_position || 'center';

    return (
        <div className="galleryCard-photoFrame">
            <img
                src={src}
                alt={item.caption || 'In Motion Dance photo'}
                style={{ objectPosition: position }}
                onError={(e) => { e.currentTarget.src = comingSoon; }}
            />
        </div>
    );
}

export default function Gallery() {
    const [gallery, setGallery] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetchGallery()
            .then((data) => { if (!cancelled) setGallery(data); })
            .catch((err) => { if (!cancelled) setError(err.message); });
        return () => { cancelled = true; };
    }, []);

    return (
        <div className="gallery-content">
            <Helmet>
                <title>In Motion Dance | Gallery</title>
            </Helmet>
            <h1>Gallery</h1>

            {error && (
                <p className="gallery-error">
                    We couldn't load the gallery ({error}). Please refresh, or contact the studio
                    if this keeps happening.
                </p>
            )}

            {!error && !gallery && <p className="gallery-loading">Loading photos…</p>}

            {gallery && (
                <div className="gallery-grid">
                    {gallery.map((item, i) => (
                        <div className="galleryCard" key={`${item.photo_key || item.photo_url}-${i}`}>
                            <GalleryPhoto item={item} />
                            {item.caption && <p className="galleryCard-caption">{item.caption}</p>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
